/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable array-callback-return */
import Roboto from '../../../../../../assets/fonts/Roboto-Bold.ttf'

import {
  Circle,
  ClipPath,
  Defs,
  Document,
  Font,
  G,
  Image,
  Image as PDFImage,
  Line,
  LinearGradient,
  Page,
  Path,
  Rect,
  Stop,
  StyleSheet,
  Svg,
  Text,
  View
} from '@react-pdf/renderer'
import { iRelatorioSI } from '../../interfaceRelatorioSI'
import CapaImage from '../../assets/Capa.png'
import LogoImage from '../../assets/Logo.png'
import PastinhaImage from '../../assets/pasta.png'
import ArvoreImage from '../../assets/arvore.png'
import DiplomaImage from '../../assets/diploma.png'
import { Footer } from './Components/Footer'
import React from 'react'
import { IcoDicasGR1, IcoPontosAtencaoGR1, IcoPontosFortesGR1, SpacerImage } from '../../../../../../assets/ImageAssets'
import { PropInvalida } from '../../../../../../Utils/Helper'

interface iProps {
  model: iRelatorioSI
}

export interface DominanciaSectionProps {
  letra: string
  titulo: string
  coluna1A: string[]
  coluna1B: string[]
  dicasAutocoaching1: string[]
  coluna2A: string[]
  coluna2B: string[]
  dicasAutocoaching2: string[]
}

export const RelatorioPDF: React.FC<iProps> = ({
  model
}) => {
  Font.register({
    family: 'Roboto',
    fonts: [{
      src: Roboto
    }]
  })

  const styles = StyleSheet.create({
    DefaultPage: {
      flexDirection: 'column',
      paddingBottom: '32px',
      justifyContent: 'space-between'
    },
    Sumario: {
      backgroundColor: model.corEmpresa ?? '#1961E0',
      flexDirection: 'column',
      justifyContent: 'center',
      color: 'white',
      padding: 32
    },
    Capa: {
      position: 'relative',
      backgroundColor: model.corEmpresa
    },
    FlexCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    Image: {
      objectFit: 'cover'
    },
    Title: {
      fontSize: '28px',
      color: model.corEmpresa ?? '#1961E0',
      fontFamily: 'Roboto',
      textAlign: 'center'
    },
    ContentPage: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      paddingHorizontal: '32px',
      paddingVertical: '16px',
      fontSize: '12px'
    },
    ContentTitle: {
      fontSize: '14px',
      fontFamily: 'Roboto'
    }
  })

  function GetContentPage(children: any, page?: string): any {
    return (<Page size={'A4'} style={styles.DefaultPage}>
      {!model.corEmpresa
        ? <View>
        <Svg viewBox="0 0 210 40" width="210px" height="40px">
          <Defs>
            <LinearGradient id="myLinearGradient" x1="0" x2="1" y1="0" y2="0">
              <Stop offset="5%" stopColor="#1961E0" />
              <Stop offset="95%" stopColor="#66046B" />
            </LinearGradient>
          </Defs>

          <Rect fill="url(#myLinearGradient)" x="0" y="0" width="210" height={'40'} />
        </Svg>
      </View>
        : <View style={{ width: '100%', height: '40px', backgroundColor: model.corEmpresa }}>
      </View>}
      {children}
      <Footer nomeAvaliado={model.nome} nomeVaga={model.funcao.nome} numeroPagina={page}/>
    </Page>)
  }

  function GetCaixaColorida(cor: string, titulo: string, texto: string): any {
    return <View style={{ padding: '12px 18px', backgroundColor: `${cor}${cor === '#B4E5A2' ? 75 : 45}`, display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <Text style={styles.ContentTitle}>{titulo} {'>>'}</Text>
      <Text style={{ fontSize: '14px' }}>{texto}</Text>
    </View>
  }

  function GetCaixaColoridaArray(cor: string, titulo: string, textos: string[], width: number, height: number): any {
    return <View style={{ padding: '12px 18px', width: `${width}px`, height: `${height}px`, backgroundColor: `${cor}`, display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Text style={{ ...styles.ContentTitle, color: 'white' }}>{titulo}</Text>
      <View style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
        {textos.map(e => {
          return <Text style={{ fontSize: height === 390 ? '12px' : textos.length > 3 ? textos.length > 4 ? textos.length > 5 ? '9px' : '10px' : '11px' : '12px', textAlign: 'justify', color: 'white' }}>• {e}</Text>
        })}
      </View>
    </View>
  }

  function GetBoxesCurriculo(titulo: string, textos: string[], corTitulo: string, corTexto: string, backgroundColor: string, ImageSRC?: any): any {
    return <View style={{ backgroundColor: backgroundColor, paddingHorizontal: '18px', paddingVertical: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <View style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center' }}>
        {ImageSRC && <PDFImage src={ImageSRC} style={{ height: GetFontSizeTitulo() === '12px' ? '20px' : '30px', ...styles.Image }}/>}
        <Text style={{ fontSize: GetFontSizeTitulo(), fontFamily: 'Roboto', color: corTitulo }}>{titulo}</Text>
      </View>
      <View style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {textos.map(e => {
          return <Text style={{ fontSize: GetFontSizeCurriculos(), color: corTexto }}>• {e}</Text>
        })}
      </View>
    </View>
  }

  function GetFontSizeFuncao(): string {
    const lengthTotal = model.funcao.competencias.length + model.funcao.requisitos.length

    if (lengthTotal > 14) return '9px'
    if (lengthTotal > 12) return '10px'
    if (lengthTotal > 9) return '11px'

    return '12px'
  }

  function GetFontSizeCurriculos(): string {
    const lengthTotal = model.curriculo.resumoTecnico.length + model.curriculo.formacao.length + model.curriculo.experiencia.length

    if (lengthTotal > 44) return '7px'
    if (lengthTotal > 38) return '8px'
    if (lengthTotal > 30) return '9px'

    return '10px'
  }

  function GetFontSizeTitulo(): string {
    const lengthTotal = model.curriculo.resumoTecnico.length + model.curriculo.formacao.length + model.curriculo.experiencia.length

    if (lengthTotal > 38) return '11px'
    if (lengthTotal > 30) return '12px'

    return '13px'
  }

  function GetLengthDados(): number {
    return model.curriculo.resumoTecnico.length + model.curriculo.formacao.length + model.curriculo.experiencia.length
  }

  function GetHeightFromModel(baseLength: number): number {
    const totalLength =
      model.curriculo.resumoTecnico.length +
      model.curriculo.formacao.length +
      model.curriculo.experiencia.length

    if (totalLength === 0) return 0

    const basePercentage = (baseLength / totalLength)

    return (240 * basePercentage) + 80
  }

  function GetFontSizeAderencia(): string {
    const lengthTotal =
      model.aderenciaFuncao.atitudesPontoAtencao.length +
      model.aderenciaFuncao.atitudesPontoForte.length +
      model.aderenciaFuncao.conhecimentoPontoAtencao.length +
      model.aderenciaFuncao.conhecimentoPontoForte.length +
      model.aderenciaFuncao.habilidadesPontoAtencao.length +
      model.aderenciaFuncao.habilidadesPontoForte.length

    if (lengthTotal > 22) return '7px'
    if (lengthTotal > 18) return '8px'
    if (lengthTotal > 14) return '9px'

    return '10px'
  }

  function GetFontSizePontos(): string {
    const lengthTotal =
      (model.perfilPI.relacionamento1PontosDicas?.length ?? 0) +
      (model.perfilPI.relacionamento1PontosAtencao?.length ?? 0) +
      (model.perfilPI.relacionamento1PontosFortes?.length ?? 0)

    if (lengthTotal > 14) return '8px'
    if (lengthTotal > 12) return '9px'

    return '10px'
  }

  function GetHeightFromAderencia(baseLength: number): number {
    const totalLength =
      model.aderenciaFuncao.atitudesPontoAtencao.length +
      model.aderenciaFuncao.atitudesPontoForte.length +
      model.aderenciaFuncao.conhecimentoPontoAtencao.length +
      model.aderenciaFuncao.conhecimentoPontoForte.length +
      model.aderenciaFuncao.habilidadesPontoAtencao.length +
      model.aderenciaFuncao.habilidadesPontoForte.length

    if (totalLength === 0) return 0

    const basePercentage = (baseLength / totalLength)

    return (460 * basePercentage) + 60
  }

  function GetContainerAderencia(): any {
    const cor = model.aderencia === 1 ? '#FF0000' : model.aderencia === 2 ? '#FFFF00' : '#B4E5A2'
    const texto = model.aderencia === 1 ? 'Não aderente' : model.aderencia === 2 ? 'Aderente com ressalvas' : 'Aderente'
    return <View style={{ paddingVertical: '6px', backgroundColor: `${cor}${cor === '#B4E5A2' ? '75' : '45'}`, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px', borderRadius: '4px' }}>
      <Text style={styles.ContentTitle}>{texto}</Text>
    </View>
  }

  function GetHeight(heigth: number, firstLength: number, secondLength: number): number {
    const totalLength = firstLength + secondLength
    const firstPercentage = (firstLength / totalLength) * 100
    return (heigth / 100) * firstPercentage
  }

  function GetBoxesAderencia(titulo: string, textos1: string[], textos2: string[]): any {
    return <View style={{ paddingHorizontal: '10px', maxHeight: `${GetHeightFromAderencia(textos1.length + textos2.length)}px`, display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Text style={{ fontSize: '18px', fontFamily: 'Roboto', color: '#1961E0' }}>{titulo}</Text>
      <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <Text style={{ fontSize: '12px', fontFamily: 'Roboto' }}>Pontos fortes</Text>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '2px', paddingLeft: '8px' }}>
          {textos1.map(e => {
            return <Text style={{ fontSize: GetFontSizeAderencia() }}>• {e}</Text>
          })}
        </View>
      </View>
      <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <Text style={{ fontSize: '12px', fontFamily: 'Roboto' }}>Potenciais pontos de atenção</Text>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '2px', paddingLeft: '8px' }}>
          {textos2.map(e => {
            return <Text style={{ fontSize: GetFontSizeAderencia() }}>• {e}</Text>
          })}
        </View>
      </View>
    </View>
  }

  function GraficoSelf(fatA: number, fatB: number, fatC: number, fatD: number, width: number): any {
    const norma = 238
    const amplitudeGrafico = 79
    let fatorA = fatA
    let fatorB = fatB
    let fatorC = fatC
    let fatorD = fatD

    if (fatorA < -3) fatorA = -2.82
    if (fatorA > 3) fatorA = 2.82

    if (fatorB < -3) fatorB = -2.82
    if (fatorB > 3) fatorB = 2.82

    if (fatorC < -3) fatorC = -2.82
    if (fatorC > 3) fatorC = 2.82

    if (fatorD < -3) fatorD = -2.82
    if (fatorD > 3) fatorD = 2.82

    const fatorAx = norma + fatorA * amplitudeGrafico
    const fatorBx = norma + fatorB * amplitudeGrafico
    const fatorCx = norma + fatorC * amplitudeGrafico
    const fatorDx = norma + fatorD * amplitudeGrafico

    return (
      <Svg width={width} height={width * (106 / 478)} viewBox="0 0 478 106" fill="none">
        <G clipPath="url(#clip0_1_2)">
          <Path d="M476.92 0.5H0.5V101.27H476.92V0.5Z" fill="white" />
          <Path d="M476.42 1V100.77H1V1H476.42ZM477.42 0H0V100.77H477.42V0Z" fill="#C9CBCC" />
          <Path d="M238.71 91.77L246.71 105.77H230.71L238.71 91.77Z" fill="black" />
          <Path d="M477.42 99.77H0V105.77H477.42V99.77Z" fill="#3189C0" />
          <Path d="M238.71 381.14V84.616" stroke="#C9CBCC" strokeWidth="0.617401"/>

          {/* Círculos */}
          <Circle cx={fatorAx} cy={21.154} r={6.49} fill="#000000" />
          <Circle cx={fatorBx} cy={42.308} r={6.49} fill="#000000" />
          <Circle cx={fatorCx} cy={63.462} r={6.49} fill="#000000" />
          <Circle cx={fatorDx} cy={84.616} r={6.49} fill="#000000" />

          {/* Linhas conectando os círculos */}
          <Line x1={fatorAx} y1={21.154} x2={fatorBx} y2={42.308} stroke="#252525" strokeWidth="2"/>
          <Line x1={fatorBx} y1={42.308} x2={fatorCx} y2={63.462} stroke="#252525" strokeWidth="2"/>
          <Line x1={fatorCx} y1={63.462} x2={fatorDx} y2={84.616} stroke="#252525" strokeWidth="2"/>

          {fatA > 3 && <Path d="M476 23L469.25 30.7942L469.25 15.2058L476 23Z" fill="#3189C0"/>}
          {fatB > 3 && <Path d="M476 42L469.25 49.7942L469.25 34.2058L476 42Z" fill="#3189C0"/>}
          {fatC > 3 && <Path d="M476 63L469.25 70.7942L469.25 55.2058L476 63Z" fill="#3189C0"/>}
          {fatD > 3 && <Path d="M476 84L469.25 91.7942L469.25 76.2058L476 84Z" fill="#3189C0"/>}
          {fatA < -3 && <Path d="M1 23L7.75 30.7942L7.75 15.2058L1 23Z" fill="#3189C0"/>}
          {fatB < -3 && <Path d="M1 42L7.75 49.7942L7.75 34.2058L1 42Z" fill="#3189C0"/>}
          {fatC < -3 && <Path d="M1 63L7.75 70.7942L7.75 55.2058L1 63Z" fill="#3189C0"/>}
          {fatD < -3 && <Path d="M1 84L7.75 91.7942L7.75 76.2058L1 84Z" fill="#3189C0"/>}
        </G>
        <Defs>
          <ClipPath id="clip0_1_2">
            <Rect width="477.42" height="105.77" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    )
  }

  function GetColor(quadrante: string): string {
    if (quadrante === 'EXTREMAMENTE') return '#444444'
    if (quadrante === 'MUITO') return '#828282'
    return '#BBBBBB'
  }

  function isIntervaloAtivo(pontuacao: number, i: number, rangeNeutro: boolean): boolean {
    if (rangeNeutro && i === 2) return true

    const intervalos = [
      { min: -3.0, max: -2.1 },
      { min: -2, max: -1.01 },
      { min: -1, max: -0.19 },
      { min: 0.21, max: 1 },
      { min: 1.01, max: 2 },
      { min: 2.01, max: 3.0 }
    ]
    return !rangeNeutro && pontuacao >= intervalos[i].min && pontuacao <= intervalos[i].max
  }

  function GetDominanciaSection(pontuacao: number, {
    letra,
    titulo,
    coluna1A,
    coluna1B,
    dicasAutocoaching1,
    coluna2A,
    coluna2B,
    dicasAutocoaching2
  }: DominanciaSectionProps): any {
    const left = pontuacao < -0.2
    const right = pontuacao > 0.2
    const rangeNeutro = pontuacao >= -0.2 && pontuacao <= 0.2

    return (
    <View style={{ display: 'flex', flexDirection: 'column' }}>
      <Text style={{ fontSize: 12, fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: '6px' }}>{titulo}</Text>
      <View style={{ display: 'flex', width: '540px', flexDirection: 'row', gap: 0, position: 'relative', alignItems: 'flex-end' }}>
        {['EXTREMAMENTE', 'MUITO', ...(rangeNeutro ? ['NEUTRO'] : ['MODERADAMENTE', 'MODERADAMENTE']), 'MUITO', 'EXTREMAMENTE'].map((e, i) => {
          return <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '#1961E0' : GetColor(e), border: `1px solid ${isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '#1961E0' : GetColor(e)}`, borderLeft: ((!rangeNeutro && i === 3 && !left) || (left && i === 0)) ? '1px solid #1961E0' : undefined, height: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '32px' : '26px', width: rangeNeutro && i === 2 ? '182px' : '90px', borderRightColor: ((right && i === 5) || (!rangeNeutro && i === 2 && left)) ? '#1961E0' : undefined, borderTopColor: right && i > 2 ? '#1961E0' : left && i < 3 ? '#1961E0' : undefined, borderTopLeftRadius: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '4px' : undefined, borderTopRightRadius: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '4px' : undefined }}>
            <Text style={{ fontSize: 8, color: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '#fff' : GetColor(e) === '#BBBBBB' ? '#000' : '#fff' }}>{e}</Text>
          </View>
        })}
      </View>
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '270px', paddingHorizontal: '12px', paddingTop: '12px', paddingBottom: '16px', border: `1px solid ${left ? '#1961E0' : '#C9C9C9'}`, borderTop: 'none', borderRight: left ? undefined : 'none', backgroundColor: left ? '#E3E3E3' : undefined, opacity: right ? 0.5 : undefined }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px', height: '125px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS FORTES</Text>
              {coluna1A.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS DE ATENÇÃO</Text>
              {coluna1B.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
          </View>
          <View style={{ height: '1px', width: '246px', backgroundColor: '#C9C9C9' }} />
          <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '240px' }}>
            <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>DICAS DE AUTOCOACHING</Text>
            {dicasAutocoaching1.map((item, index) => (
              <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
            ))}
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '270px', paddingHorizontal: '12px', paddingTop: '12px', paddingBottom: '16px', border: `1px solid ${right ? '#1961E0' : '#C9C9C9'}`, borderLeft: right ? '1px solid #1961E0' : left ? 'none' : undefined, borderTop: 'none', backgroundColor: right ? '#E3E3E3' : undefined, opacity: left ? 0.5 : undefined }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px', height: '125px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS FORTES</Text>
              {coluna2A.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS DE ATENÇÃO</Text>
              {coluna2B.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
          </View>
          <View style={{ height: '1px', width: '246px', backgroundColor: '#C9C9C9' }} />
          <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '240px' }}>
            <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>DICAS DE AUTOCOACHING</Text>
            {dicasAutocoaching2.map((item, index) => (
              <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
            ))}
          </View>
        </View>
      </View>
      <View
        style={{
          position: 'absolute',
          top: '44px',
          left: `${((pontuacao + 3) / 6) * 540 - 8}px`,
          width: 16,
          height: 16,
          borderRadius: 8,
          fontFamily: 'Roboto',
          fontWeight: 'bold',
          backgroundColor: '#fff',
          border: '1px solid #1961E0',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Text style={{ fontSize: 8, color: '#1961E0' }}>{letra}</Text>
      </View>
    </View>
    )
  }

  function GetPontosRelacionamento(icone: any, titulo: string, textos: string[], lastItem?: boolean): any {
    return <View style={{ paddingHorizontal: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <View style={{ paddingHorizontal: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px' }}>
        <Image src={icone} style={{ width: '14px', height: '14px' }}/>
        <Text style={{ fontSize: '11px', fontFamily: 'Roboto' }}>{titulo}</Text>
      </View>
      <View style={{ paddingHorizontal: '10px', display: 'flex', flexDirection: 'column', gap: '6px', paddingBottom: !lastItem ? '22px' : undefined, borderBottom: !lastItem ? '2px solid rgb(194, 194, 194)' : undefined }}>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft: '8px' }}>
          {textos.map(e => {
            return <Text style={{ fontSize: GetFontSizePontos() }}>• {e}</Text>
          })}
        </View>
      </View>
    </View>
  }

  function GetHeightFromPerfilPI(baseLength: number): number {
    const totalLength =
      model.perfilPI.pontosFortes.length +
      model.perfilPI.pontosDeAtencao.length

    if (totalLength === 0) return 0

    const basePercentage = (baseLength / totalLength)

    return (380 * basePercentage) + 90
  }

  function GetFontSizePerfilPI(): string {
    const lengthTotal =
      model.perfilPI.pontosFortes.length +
      model.perfilPI.pontosDeAtencao.length

    if (lengthTotal > 18) return '8px'
    if (lengthTotal > 14) return '10px'
    if (lengthTotal > 11) return '11px'

    return '12px'
  }

  function GetCaixaColoridaPerfilPI(cor: string, titulo: string, textos: string[], icon?: any): any {
    return <View style={{ padding: '12px 18px', minHeight: `${GetHeightFromPerfilPI(textos.length) - 80}px`, maxHeight: `${GetHeightFromPerfilPI(textos.length)}px`, paddingHorizontal: '24px', backgroundColor: `${cor}`, display: 'flex', flexDirection: 'column', gap: '14px' }}>
      <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', justifyContent: 'center', alignItems: 'center' }}>
        {icon && <PDFImage src={icon} style={{ width: '24px', height: '24px', ...styles.Image }}/>}
        <Text style={{ ...styles.ContentTitle, color: 'white', textAlign: 'center' }}>{titulo}</Text>
      </View>
      <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {textos.map(e => {
          return <Text style={{ fontSize: GetFontSizePerfilPI(), textAlign: 'justify', color: 'white' }}>• {e}</Text>
        })}
      </View>
    </View>
  }

  function GetFontSizeEstiloGestao(isDoisItens?: boolean): string {
    const lengthTotal = isDoisItens ? (model.perfilPI.sugestaoDesenvolvimento.length + model.perfilPI.sugestaoGestao.length) : model.perfilPI.estiloGestao.length

    if (lengthTotal > 18) return '10px'
    if (lengthTotal > 14) return '12px'
    if (lengthTotal > 10) return '13px'

    return '14px'
  }

  function GetHeightSugestao(baseLength: number): number {
    let len1 = 0
    let len2 = 0
    model.perfilPI.sugestaoDesenvolvimento.forEach(e => len1 += e.length)
    model.perfilPI.sugestaoGestao.forEach(e => len2 += e.length)
    const totalLength = len1 + len2
    const firstPercentage = (baseLength / totalLength) * 100
    return ((460 / 100) * firstPercentage) + 60
  }

  function GetBoxEstiloGestao(titulo: string, textos: string[], isDoisItens?: boolean): any {
    let len = 0
    textos.forEach(e => len += e.length)
    return <View style={{ paddingHorizontal: '10px', display: 'flex', maxHeight: isDoisItens ? `${GetHeightSugestao(len)}px` : undefined, flex: '1', flexDirection: 'column', gap: '18px' }}>
      <Text style={{ fontSize: '18px', fontFamily: 'Roboto', color: '#1961E0' }}>{titulo}</Text>
      <View style={{ display: 'flex', flexDirection: 'column', gap: '12px', paddingLeft: '10px' }}>
        {textos.map(e => {
          return <Text style={{ fontSize: GetFontSizeEstiloGestao(isDoisItens) }}>• {e}</Text>
        })}
      </View>
    </View>
  }

  return (
    <Document>
      <Page size="A4" style={styles.Capa}>
        {!model.corEmpresa && <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Svg viewBox="0 0 210 297" width="100%" height="100%">
            <Defs>
              <LinearGradient id="myLinearGradient" x1="0" x2="1" y1="0" y2="0">
                <Stop offset="5%" stopColor="#1961E0" />
                <Stop offset="95%" stopColor="#66046B" />
              </LinearGradient>
            </Defs>

            <Rect fill="url(#myLinearGradient)" x="0" y="0" width="210" height="297" />
          </Svg>
        </View>}
        <View style={{ ...styles.FlexCenter, padding: '60px 0 80px 0', marginHorizontal: '2px', backgroundColor: '#ffffff', flexDirection: 'column', gap: '14px', marginTop: '97px' }}>
          <Text style={{ fontSize: '34px', fontFamily: 'Roboto' }}>Assessment</Text>
          <View style={{ ...styles.FlexCenter, flexDirection: 'column', gap: '4px' }}>
            <Text style={{ fontSize: '20px', fontFamily: 'Roboto' }}>Nome: {model.nome}</Text>
            <Text style={{ fontSize: '20px', fontWeight: 'thin' }}>Vaga: {model.funcao.nome}</Text>
          </View>
          <Image src={model.logoEmpresa} style={{ ...styles.Image, height: '120px' }}/>
        </View>
        <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', flexDirection: 'row', gap: '14px' }}>
          <PDFImage src={LogoImage} style={{ ...styles.Image, maxHeight: '65px', marginBottom: '60px', maxWidth: '150px', zIndex: 999 }}/>
          <PDFImage src={CapaImage} style={{ ...styles.Image, width: '340px', marginTop: '-60px', zIndex: 999 }}/>
        </View>
      </Page>

      {GetContentPage(
        <View style={{ ...styles.ContentPage, gap: '16px' }}>
          <Text style={styles.Title}>Introdução ao Assessment</Text>
          <Text style={{ ...styles.ContentTitle, marginBottom: '6px' }}>O que encontrará nesse relatório</Text>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={styles.ContentTitle}>1. Análise de Aderência</Text>
            <Text>
              Avaliação do profissional em relação aos requisitos técnicos e comportamentais da função, destacando seu nível de compatibilidade com o cargo.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={styles.ContentTitle}>2. Principais Competências e Áreas de Atenção</Text>
            <Text>
              Resumo dos pontos fortes do profissional e das áreas que podem requerer desenvolvimento para maximizar seu desempenho no cargo.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={styles.ContentTitle}>3.Orientações para Integração</Text>
            <Text>
              Recomendações sobre como o profissional pode ser melhor integrado à equipe, incluindo estratégias de onboarding e desenvolvimento para garantir o sucesso na função.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text>
              Este documento fornece insights comportamentais e sugestões práticas para integração e desenvolvimento no novo papel
            </Text>
          </View>
          <Text style={styles.ContentTitle}>A classificação do profissional será realizada em 3 níveis</Text>
          {GetCaixaColorida('#B4E5A2', 'Aderente', 'O profissional atende de forma satisfatória aos requisitos e expectativas da vaga, demonstrando compatibilidade com o perfil desejado.')}
          {GetCaixaColorida('#FFFF00', 'Aderente com ressalvas', 'O profissional atende parcialmente aos requisitos e expectativas da vaga, isso pode necessitar de desenvolvimento ou ajustes acima do esperado para o tempo disponível.')}
          {GetCaixaColorida('#FF0000', 'Não aderente', 'O profissional não atende aos requisitos essenciais da vaga e apresenta limitações significativas em relação ao perfil desejado.')}
          <View style={{ flexDirection: 'column', gap: '6px' }}>
            <Text style={styles.ContentTitle}>Lembre-se</Text>
            <Text>
              • O profissional à vaga receberá um breve relatório com o Assessment Comportamental
            </Text>
            <Text>
              • O gestor da vaga receberá o relatório completo, o mesmo entregue ao RH.
            </Text>
          </View>
        </View>
      )}

      {GetContentPage(<View style={{ ...styles.ContentPage, gap: '16px' }}>
        <Text style={styles.Title}>Resumo do profissional</Text>
        <View style={{ display: 'flex', gap: '18px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: '4px' }}>
          <View style={{ borderRadius: '50%', width: '88px', height: '88px', border: '1px solid #E3E3E3' }}>
            <Image style={{ borderRadius: '50%', width: '88px', height: '88px', objectFit: 'cover' }} src={model.urlAvatar ? model.urlAvatar : 'https://sigah.blob.core.windows.net/assets/no_avatar.png'}/>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center' }}>
              <Image src={model.perfilPI.urlAvatarSelo} style={{ width: '15px', height: '15px' }}/>
              <Text style={styles.ContentTitle}>{model.perfilPI.seloPi}</Text>
            </View>
            <Text style={{ width: '280px', textAlign: 'justify' }}>{model.perfilPI.descricaoSelo}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '8px', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Text style={{ fontSize: '9px', fontFamily: 'Roboto' }}>Aderente</Text>
              <View style={{ backgroundColor: '#B4E5A2', borderRadius: '50%', width: '9px', height: '9px' }}></View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '8px', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Text style={{ fontSize: '9px', fontFamily: 'Roboto' }}>Aderente com ressalvas</Text>
              <View style={{ backgroundColor: '#FFFF00', borderRadius: '50%', width: '9px', height: '9px' }}></View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '8px', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Text style={{ fontSize: '9px', fontFamily: 'Roboto' }}>Não aderente</Text>
              <View style={{ backgroundColor: '#FF0000', borderRadius: '50%', width: '9px', height: '9px' }}></View>
            </View>
          </View>
        </View>
        {GetContainerAderencia()}
        <View style={{ display: 'flex', flexDirection: 'column', gap: '4px', height: '90px' }}>
          <Text style={styles.ContentTitle}>{model.nome}</Text>
          <Text style={{ fontSize: '12px', textAlign: 'justify', width: '100%' }}>{model.percepcaoGeral.map((e, i) => {
            if (i > 0) return ` ${e}${e[(e.length - 1)] !== '.' ? '.' : ''}`

            return `${e}${e[(e.length - 1)] !== '.' ? '.' : ''}`
          })}</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
          {GetCaixaColoridaArray('#104862', 'Pontos de aderência à posição', model.pontosFortes, 210, 390)}
          <View style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {GetCaixaColoridaArray('#C88800', 'Potenciais pontos de atenção à posição', model.pontosDeAtencao, 310, GetHeight(382, model.pontosDeAtencao.length, model.recomendacoes.length))}
            {GetCaixaColoridaArray('#7F7F7F', 'Recomendação', model.recomendacoes, 310, GetHeight(382, model.recomendacoes.length, model.pontosDeAtencao.length))}
          </View>
        </View>
      </View>)}

      <Page style={styles.Sumario}>
        <View style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
          <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '72px' }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 38,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                marginBottom: '28px'
              }}
            >
              Sumário
            </Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>05</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Premissas da vaga</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>06</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Dados pessoais e experiência profissional</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>07</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Aderência à função</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>08</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Perfil comportamental do profissional em relação à função</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>09</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Estilos de gestão e de persuasão do profissional</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>10</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Relação com o Gestor</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>11</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Sugestões para gestão e desenvolvimento do profissional</Text>
              </View>
            </View>
            <View style={{ display: 'flex', gap: '16px', fontSize: 16, justifyContent: 'center' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
                <Text style={{ fontSize: 22 }}>12</Text>
                <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
                <Text>Quadro de desenvolvimento pessoal PI®</Text>
              </View>
            </View>
          </View>
        </View>
        <Footer nomeAvaliado={model.nome} nomeVaga={model.funcao.nome} sumario/>
      </Page>

      {GetContentPage(<View style={{ display: 'flex', flexDirection: 'column' }}>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '12px', height: '180px', alignItems: 'center', paddingHorizontal: '32px', paddingBottom: '24px', justifyContent: 'flex-start' }}>
          <Text style={styles.Title}>Premissas</Text>
          <View style={{ display: 'flex', gap: '18px', flexDirection: 'row', alignItems: 'center', paddingHorizontal: '22px' }}>
            <View style={{ width: '90px' }}>
              <PDFImage src={PastinhaImage} style={{ width: '90px', ...styles.Image }}/>
            </View>
            <View>
              <Text style={{ width: '370px', textAlign: 'justify', fontSize: '13px' }}>{model.funcao.premissas}</Text>
            </View>
          </View>
        </View>
        <View style={{ backgroundColor: model.corEmpresa ?? '#1961E0', paddingHorizontal: '24px', height: '500px', paddingVertical: '32px', display: 'flex', flexDirection: 'column', gap: '26px' }}>
          <Text style={{ fontSize: '22px', fontFamily: 'Roboto', color: 'white', textAlign: 'center' }}>Resumo descrição da função</Text>
          <Text style={{ fontSize: GetFontSizeFuncao(), color: 'white' }}>{model.funcao.descricao}</Text>
          <Text style={{ ...styles.ContentTitle, color: 'white' }}>Requisitos</Text>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {model.funcao.requisitos.map(e => {
              return <Text style={{ fontSize: GetFontSizeFuncao(), color: 'white' }}>• {e}</Text>
            })}
          </View>
          <Text style={{ ...styles.ContentTitle, color: 'white' }}>Competências desejáveis</Text>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {model.funcao.competencias.map(e => {
              return <Text style={{ fontSize: GetFontSizeFuncao(), color: 'white' }}>• {e}</Text>
            })}
          </View>
        </View>
      </View>, '5')}

      {GetLengthDados() > 18
        ? <>
          {GetContentPage(<View style={{ ...styles.ContentPage, gap: '22px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Text style={styles.Title}>Dados pessoais e</Text>
              <Text style={styles.Title}>experiência profissional</Text>
            </View>
            <View style={{ display: 'flex', gap: '24px', flexDirection: 'row', alignItems: 'center', paddingHorizontal: '22px' }}>
              <View style={{ width: '120px', height: '120px', borderRadius: '50%' }}>
                <PDFImage src={model.urlAvatar ? model.urlAvatar : 'https://sigah.blob.core.windows.net/assets/no_avatar.png'} style={{ width: GetFontSizeTitulo() === '12px' ? '105px' : '120px', height: GetFontSizeTitulo() === '12px' ? '105px' : '120px', borderRadius: '50%', ...styles.Image }}/>
              </View>
              <View>
                <Text style={{ width: '350px', textAlign: 'justify', fontSize: '12px' }}>{model.curriculo.resumo}</Text>
              </View>
            </View>
            {GetBoxesCurriculo('Resumo técnico', model.curriculo.resumoTecnico, 'white', 'white', '#404040')}
          </View>, '6')}
          {GetContentPage(<View style={{ ...styles.ContentPage, gap: '22px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Text style={styles.Title}>Dados pessoais e</Text>
              <Text style={styles.Title}>experiência profissional</Text>
            </View>
            {GetBoxesCurriculo('Formação e estudos', model.curriculo.formacao, '#1961E0', 'black', '#F0F0F0', DiplomaImage)}
            {GetBoxesCurriculo('Experiências', model.curriculo.experiencia, '#1961E0', 'black', '#F0F0F0', ArvoreImage)}
          </View>, '7')}
        </>
        : GetContentPage(<View style={{ ...styles.ContentPage, gap: '14px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Text style={styles.Title}>Dados pessoais e</Text>
            <Text style={styles.Title}>experiência profissional</Text>
          </View>
          <View style={{ display: 'flex', gap: '24px', flexDirection: 'row', alignItems: 'center', paddingHorizontal: '22px' }}>
            <View style={{ width: '120px', height: '120px', borderRadius: '50%' }}>
              <PDFImage src={model.urlAvatar ? model.urlAvatar : 'https://sigah.blob.core.windows.net/assets/no_avatar.png'} style={{ width: GetFontSizeTitulo() === '12px' ? '105px' : '120px', height: GetFontSizeTitulo() === '12px' ? '105px' : '120px', borderRadius: '50%', ...styles.Image }}/>
            </View>
            <View>
              <Text style={{ width: '350px', textAlign: 'justify', fontSize: '12px' }}>{model.curriculo.resumo}</Text>
            </View>
          </View>
          {GetBoxesCurriculo('Resumo técnico', model.curriculo.resumoTecnico, 'white', 'white', '#404040')}
          {GetBoxesCurriculo('Formação e estudos', model.curriculo.formacao, '#1961E0', 'black', '#F0F0F0', DiplomaImage)}
          {GetBoxesCurriculo('Experiências', model.curriculo.experiencia, '#1961E0', 'black', '#F0F0F0', ArvoreImage)}
        </View>, '6')}

      {GetContentPage(<View style={{ ...styles.ContentPage, gap: '22px' }}>
          <Text style={styles.Title}>Resumo</Text>
          {GetBoxesAderencia('Conhecimento', model.aderenciaFuncao.conhecimentoPontoForte, model.aderenciaFuncao.conhecimentoPontoAtencao)}
          {GetBoxesAderencia('Habilidades', model.aderenciaFuncao.habilidadesPontoForte, model.aderenciaFuncao.habilidadesPontoAtencao)}
          {GetBoxesAderencia('Atitudes', model.aderenciaFuncao.atitudesPontoForte, model.aderenciaFuncao.atitudesPontoAtencao)}
        </View>, GetLengthDados() > 18 ? '8' : '7')}

      {GetContentPage(<View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '20px', flex: 1, paddingBottom: '26px' }}>
          <View style={{ ...styles.ContentPage, gap: '22px', height: '210px', paddingBottom: '0px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Text style={styles.Title}>Perfil comportamental do profissional em</Text>
              <Text style={styles.Title}>relação à função</Text>
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '24px', alignItems: 'center' }}>
                <View style={{ width: '78px', height: '78px', borderRadius: '50%' }}>
                  <PDFImage src={model.urlAvatar ? model.urlAvatar : 'https://sigah.blob.core.windows.net/assets/no_avatar.png'} style={{ width: '78px', height: '78px', borderRadius: '50%', ...styles.Image }}/>
                </View>
                {GraficoSelf(model.perfilPI.self_A, model.perfilPI.self_B, model.perfilPI.self_C, model.perfilPI.self_D, 350)}
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '24px', alignItems: 'center' }}>
                <View style={{ width: '78px', height: '78px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Image src={model.perfilPI.urlAvatarSelo} style={{ width: '52px', height: '52px' }}/>
                </View>
                <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <Text style={styles.ContentTitle}>{model.perfilPI.seloPi}</Text>
                  <Text style={{ width: '350px', textAlign: 'justify' }}>{model.perfilPI.descricaoSelo}</Text>
                </View>
              </View>
            </View>
          </View>
          {GetCaixaColoridaPerfilPI('#104862', 'Pontos Fortes', model.perfilPI.pontosFortes)}
          {GetCaixaColoridaPerfilPI('#C88800', 'Potenciais pontos de atenção', model.perfilPI.pontosDeAtencao)}
        </View>, GetLengthDados() > 18 ? '9' : '8')}

        {GetContentPage(<View style={{ ...styles.ContentPage, gap: '28px' }}>
            <Text style={styles.Title}>Estilos de gestão do profissional</Text>
            {GetBoxEstiloGestao('Como líder de pessoas ou projetos', model.perfilPI.estiloGestao)}
          </View>, GetLengthDados() > 18 ? '10' : '9')}

        {GetContentPage(<View style={{ ...styles.ContentPage, alignItems: 'center', paddingHorizontal: 0, gap: '22px' }}>
          <Text style={styles.Title}>Relação com gestor</Text>
          <View style={{ paddingHorizontal: '16px', display: 'flex', flexDirection: 'row', gap: '24px', width: '100%', height: '90px', justifyContent: 'center' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '45%' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: 'center' }}>
                <Image src={model.perfilPI.urlAvatarSelo} style={{ width: '15px', height: '15px' }}/>
                <Text style={styles.ContentTitle}>{model.nome}</Text>
              </View>
              {GraficoSelf(model.perfilPI.self_A, model.perfilPI.self_B, model.perfilPI.self_C, model.perfilPI.self_D, 240)}
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '45%' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: 'center' }}>
                <Image src={PropInvalida(model.perfilPI.urlAvatarSeloGestor) ? SpacerImage : model.perfilPI.urlAvatarSeloGestor} style={{ width: '15px', height: '15px' }}/>
                <Text style={styles.ContentTitle}>{model.nomeGestor}</Text>
              </View>
              {GraficoSelf(model.perfilPI.self_GESTOR_A, model.perfilPI.self_GESTOR_B, model.perfilPI.self_GESTOR_C, model.perfilPI.self_GESTOR_D, 240)}
            </View>
          </View>
          {(model.perfilPI.relacionamento1PontosAtencao && model.perfilPI.relacionamento1PontosDicas && model.perfilPI.relacionamento1PontosFortes) && <View style={{ display: 'flex', flexDirection: 'column', gap: '22px', justifyContent: 'center', alignItems: 'center', marginTop: '-20px' }}>
              {GetPontosRelacionamento(IcoPontosFortesGR1, 'Pontos fortes do relacionamento', model.perfilPI.relacionamento1PontosFortes ?? [])}
              {GetPontosRelacionamento(IcoPontosAtencaoGR1, 'Pontos de atenção do relacionamento', model.perfilPI.relacionamento1PontosAtencao ?? [])}
              {GetPontosRelacionamento(IcoDicasGR1, 'Dicas de relacionamento', model.perfilPI.relacionamento1PontosDicas ?? [], true)}
            </View>}
        </View>, GetLengthDados() > 18 ? '11' : '10')}

        {GetContentPage(<View style={{ ...styles.ContentPage, gap: '28px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Text style={styles.Title}>Sugestões para gestão e</Text>
            <Text style={styles.Title}>desenvolvimento do profissional</Text>
          </View>
          {GetBoxEstiloGestao(`Ao liderar ${model.nome}, o engajamento e a performance aumentam quando há`, model.perfilPI.sugestaoGestao, true)}
          {GetBoxEstiloGestao('Sugestões de desenvolvimento', model.perfilPI.sugestaoDesenvolvimento, true)}
        </View>, GetLengthDados() > 18 ? '12' : '11')}
      {GetContentPage(<View style={{ ...styles.ContentPage, alignItems: 'center', paddingHorizontal: 0, gap: '14px' }}>
        <Text style={{ ...styles.Title, marginBottom: '14px' }}>Quadro de desenvolvimento pessoal PI®</Text>
        {GetDominanciaSection(model.perfilPI.self_A, {
          letra: 'A',
          titulo: 'DOMINÂNCIA (A) - A necessidade de controlar',
          coluna1A: [
            'Compreensivo e colaborador',
            'Receptivo às decisões dos outros',
            'Estilo de gestão apoiador',
            'Interessado no bem-estar e desenvolvimento da equipe'
          ],
          coluna1B: [
            'Pode se esquivar de conversas difíceis',
            'Pode apresentar dificuldades para tomar decisões impopulares',
            'Pode ser visto como muito cauteloso ou não suficientemente estratégico'
          ],
          dicasAutocoaching1: [
            'Mude a sua mentalidade de "Eu quero acompanhar" para "Eu quero ser justo"',
            'Atenha-se ao seu ponto de vista quando souber que está correto',
            'Venha para reuniões ou situações preparado para contribuir'
          ],
          coluna2A: [
            'Conduz a mudança e desafia o status quo',
            'Busca liderar e apresentar um impacto',
            'Inovador, automotivado',
            "Capaz de pensar no 'quadro geral'"
          ],
          coluna2B: [
            'Pode ser visto como excessivamente agressivo',
            'Pode intimidar em vez de motivar',
            'Pode apresentar dificuldades para delegar autoridade',
            'Pode parecer muito pragmático e diretivo'
          ],
          dicasAutocoaching2: [
            'Busque ativamente por informações de diversas fontes',
            'Pratique a escuta ativa e permita que as pessoas expressem as suas opiniões ou ideias',
            'Pense antes de falar, reflita sobre como a sua mensagem será recebida'
          ]
        })}
        {GetDominanciaSection(model.perfilPI.self_B, {
          letra: 'B',
          titulo: 'EXTROVERSÃO (B) - A necessidade de interação social',
          coluna1A: [
            'Criativo, solucionador de problemas',
            'Conduzido por dados, analítico',
            'Abordagem refletida para comunicar informações',
            'Reflexivo e introspectivo',
            'Antecipar problemas'
          ],
          coluna1B: [
            'Pode demorar a confiar e relutar em compartilhar até que se sinta à vontade',
            'A comunicação pode ser incisiva ou minimalista',
            'Pode parecer excessivamente voltado a tarefas ou remoto'
          ],
          dicasAutocoaching1: [
            'Faça apresentações na sua área de especialidade',
            'Inicie conversas ou reserve um tempo para falar com os outros',
            'Crie processos que incentivam a comunicação'
          ],
          coluna2A: [
            'Motivador, comunicador estimulante',
            'Orientado a pessoas, sociável',
            'Estabelece coesão e colaboração da equipe',
            'Delegante ponderado'
          ],
          coluna2B: [
            'Pode ser muito otimista ou excessivamente confiante',
            'Pode priorizar ser apreciado ou ser o foco das atenções',
            'Pode parecer excessivamente conversador e superficial'
          ],
          dicasAutocoaching2: [
            'Permita aos outros a oportunidade de contribuir e influenciar os resultados',
            'Leve em conta quantos detalhes ou informações concretas são necessários ao se comunicar',
            'Pergunte sobre problemas ou riscos em potencial'
          ]
        })}
      </View>, GetLengthDados() > 18 ? '13' : '12')}
      {GetContentPage(<View style={{ ...styles.ContentPage, alignItems: 'center', paddingHorizontal: 0, gap: '14px' }}>
        <Text style={{ ...styles.Title, marginBottom: '14px' }}>Quadro de desenvolvimento pessoal PI®</Text>
        {GetDominanciaSection(model.perfilPI.self_C, {
          letra: 'C',
          titulo: 'PACIÊNCIA (C) - A necessidade de estabilidade',
          coluna1A: [
            'Proativo e voltado a resultados',
            'Capaz de lidar com prazos urgentes',
            'Capaz de lidar com variedade e mudança',
            'Multitarefas, capaz de compatibilizar prioridades'
          ],
          coluna1B: [
            'Pode parecer ser brusco; "ir direto ao assunto"',
            'Pode tender a ser intolerante quanto a atrasos, especialmente quando afetam os resultados',
            'Pode ficar frustrado em ambientes estagnados'
          ],
          dicasAutocoaching1: [
            'Reflita sobre a urgência da situação – é preciso fazer tudo neste exato momento?',
            'Reconheça que pessoas têm ritmos diferentes e administre as expectativas',
            'Cumpra as prioridades e acompanhe iniciativas até a conclusão'
          ],
          coluna2A: [
            'Calmo e estável',
            'Ouvinte atencioso',
            'Estabelece processos sólidos de grupo',
            'Dá tempo às pessoas para que processem as informações'
          ],
          coluna2B: [
            'Pode parecer desconfortável com mudanças',
            'Pode parecer analisar muito as situações ou ser cauteloso',
            'Pode ter dificuldades sob pressão',
            'Mostra-se confortável com o familiar e lento para adotar ideias novas'
          ],
          dicasAutocoaching2: [
            'Esclareça os prazos e se concentre no "quando"',
            'Administre o tempo com sabedoria – comece cedo e reserve um tempo para o inesperado',
            'Mantenha os outros informados quando ocorrer progresso'
          ]
        })}
        {GetDominanciaSection(model.perfilPI.self_D, {
          letra: 'D',
          titulo: 'FORMALIDADE (D) - A necessidade de se adequar',
          coluna1A: [
            'Abordagem flexível ante a maioria das situações e pessoas',
            'Capaz de delegar detalhes facilmente',
            'Competente com necessidades de mudanças organizacionais',
            'Lida bem com a ambiguidade'
          ],
          coluna1B: [
            'Pode apresentar limitações quanto ao acompanhamento ou à atenção a detalhes',
            'Pode não aderir à estrutura ou direção',
            'Pode parecer para os outros muito casual ou desinibido'
          ],
          dicasAutocoaching1: [
            'Busque por dados para apoiar as suas decisões',
            'Avalie as decisões a partir de várias perspectivas ou associe-se a alguém que possa oferecer uma visão equilibrada',
            'Respeite as dúvidas que outros possam ter sobre "como" as coisas deverão ser feitas'
          ],
          coluna2A: [
            'Disciplina rígida e execução',
            'Cria uma estrutura e respeito pelo plano',
            'Concentra a equipe em como fazer as coisas bem feitas',
            'Acompanhamento organizado e minucioso'
          ],
          coluna2B: [
            'Pode não ficar à vontade em situações ambíguas',
            'Pode se debater com situações que requerem flexibilidade',
            'Pode ser visto como um perfeccionista'
          ],
          dicasAutocoaching2: [
            'Aprenda como avançar quando houver informações "suficientes" disponíveis',
            'Pergunte a si mesmo: Vale a pena tanto tempo?',
            'Reconheça e respeite a flexibilidade mostrada pelos outros'
          ]
        })}
      </View>, GetLengthDados() > 18 ? '14' : '13')}
    </Document>
  )
}
